// CRM Constants and Utilities
export const ORDER_STATUSES = [
  "Contactando", "Esperando Información", "Redactor", "Revision", "Medio", "Publicada",
  "Cancelada", "Consultando", "Incidencia", "Programado", "Espera Proforma"
];

export const PAYMENT_STATUSES = ["Pendiente", "Pagado", "Parcial", "Cancelado"];

export const STATUS_COLORS = {
  "Contactando": "bg-sky-100 text-sky-800",
  "Esperando Información": "bg-amber-100 text-amber-800",
  "Redactor": "bg-yellow-100 text-yellow-800",
  "Revision": "bg-orange-100 text-orange-800",
  "Medio": "bg-fuchsia-100 text-fuchsia-800",
  "Publicada": "bg-green-100 text-green-800",
  "Cancelada": "bg-red-100 text-red-800",
  "Consultando": "bg-lime-100 text-lime-800",
  "Incidencia": "bg-pink-100 text-pink-800",
  "Programado": "bg-brand-100 text-brand-800",
  "Espera Proforma": "bg-gray-100 text-gray-800",
};

export const PAYMENT_COLORS = {
  "Pendiente": "bg-yellow-100 text-yellow-800",
  "Pagado": "bg-green-100 text-green-800",
  "Parcial": "bg-orange-100 text-orange-800",
  "Cancelado": "bg-red-100 text-red-800",
};

export const INCOME_PAYMENT_METHODS = ["Transferencia bancaria", "Paypal", "Bizum", "Tarjeta", "Efectivo"];
export const INCOME_STATUSES = ["Cobrada", "A la espera de cobro"];
export const INCOME_STATUS_COLORS = {
  "Cobrada": "bg-green-100 text-green-800",
  "A la espera de cobro": "bg-yellow-100 text-yellow-800",
};

export const EXPENSE_PAYMENT_METHODS = ["Transferencia", "Bizum", "Tarjeta", "PayPal", "Efectivo", "Otro"];
export const EXPENSE_STATUSES = ["No pagada", "Pagada", "Parcial"];
export const EXPENSE_STATUS_COLORS = {
  "No pagada": "bg-red-100 text-red-800",
  "Pagada": "bg-green-100 text-green-800",
  "Parcial": "bg-yellow-100 text-yellow-800",
};

// CRM Translations
export const CRM_TRANSLATIONS = {
  es: {
    orders: 'Pedidos',
    customers: 'Clientes',
    writers: 'Redactores',
    expenses: 'Gastos',
    income: 'Ingresos',
    accounting: 'Contabilidad',
    stats: 'Estadísticas',
    search: 'Buscar...',
    searchByNumber: 'Buscar por nº pedido...',
    addOrder: 'Nuevo Pedido',
    newOrder: 'Nuevo Pedido',
    newCustomer: 'Nuevo Cliente',
    newWriter: 'Nuevo Redactor',
    addCustomer: 'Nuevo Cliente',
    addWriter: 'Nuevo Redactor',
    addExpense: 'Nuevo Gasto',
    edit: 'Editar',
    delete: 'Eliminar',
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    loading: 'Cargando...',
    noResults: 'Sin resultados',
    noOrders: 'No hay pedidos',
    noCustomers: 'No hay clientes',
    noWriters: 'No hay redactores',
    page: 'Página',
    of: 'de',
    total: 'Total',
    status: 'Estado',
    paymentStatus: 'Estado Pago',
    allStatuses: 'Todos los estados',
    allPayments: 'Todos los pagos',
    orderNumber: 'Nº Pedido',
    externalOrderNumber: 'Nº Externo',
    customerNumber: 'Nº Cliente',
    customer: 'Cliente',
    product: 'Producto',
    productUrl: 'URL Producto',
    pvp: 'PVP',
    pc: 'PC',
    margin: 'Margen',
    date: 'Fecha',
    orderDate: 'Fecha Pedido',
    writer: 'Redactor',
    actions: 'Acciones',
    name: 'Nombre',
    email: 'Email',
    phone: 'Teléfono',
    company: 'Empresa',
    active: 'Activo',
    inactive: 'Inactivo',
    invoiceNumber: 'Nº Factura',
    provider: 'Proveedor',
    amount: 'Importe',
    baseAmount: 'Base',
    iva: 'IVA',
    irpf: 'IRPF',
    paymentMethod: 'Método Pago',
    notes: 'Notas',
    download: 'Descargar',
    downloadFiltered: 'Descargar Filtrados',
    export: 'Exportar',
    import: 'Importar',
    refresh: 'Actualizar',
    confirmDelete: '¿Estás seguro de que quieres eliminar este elemento?',
    totalOrders: 'Total Pedidos',
    totalRevenue: 'Ingresos',
    totalCost: 'Costes',
  },
  en: {
    orders: 'Orders',
    customers: 'Customers',
    writers: 'Writers',
    expenses: 'Expenses',
    income: 'Income',
    accounting: 'Accounting',
    stats: 'Statistics',
    search: 'Search...',
    searchByNumber: 'Search by order number...',
    addOrder: 'New Order',
    newOrder: 'New Order',
    newCustomer: 'New Customer',
    newWriter: 'New Writer',
    addCustomer: 'New Customer',
    addWriter: 'New Writer',
    addExpense: 'New Expense',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    loading: 'Loading...',
    noResults: 'No results',
    noOrders: 'No orders found',
    noCustomers: 'No customers found',
    noWriters: 'No writers found',
    page: 'Page',
    of: 'of',
    total: 'Total',
    status: 'Status',
    paymentStatus: 'Payment Status',
    allStatuses: 'All statuses',
    allPayments: 'All payments',
    orderNumber: 'Order #',
    externalOrderNumber: 'External #',
    customerNumber: 'Customer #',
    customer: 'Customer',
    product: 'Product',
    productUrl: 'Product URL',
    pvp: 'Sale Price',
    pc: 'Cost',
    margin: 'Margin',
    date: 'Date',
    orderDate: 'Order Date',
    writer: 'Writer',
    actions: 'Actions',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    company: 'Company',
    active: 'Active',
    inactive: 'Inactive',
    invoiceNumber: 'Invoice #',
    provider: 'Provider',
    amount: 'Amount',
    baseAmount: 'Base',
    iva: 'VAT',
    irpf: 'IRPF',
    paymentMethod: 'Payment Method',
    notes: 'Notes',
    download: 'Download',
    downloadFiltered: 'Download Filtered',
    export: 'Export',
    import: 'Import',
    refresh: 'Refresh',
    confirmDelete: 'Are you sure you want to delete this item?',
    totalOrders: 'Total Orders',
    totalRevenue: 'Revenue',
    totalCost: 'Costs',
  }
};

export const getCRMTexts = (language) => CRM_TRANSLATIONS[language] || CRM_TRANSLATIONS.es;

// 21% Spanish customers, 0% (reverse charge) for the rest — same rule as backend suggest_iva
const SPAIN_NAMES = ['', 'españa', 'espana', 'spain', 'es', 'esp'];
export const suggestIva = (country = '', nif = '') => {
  const c = (country || '').trim().toLowerCase();
  if (c && !SPAIN_NAMES.includes(c)) return 0;
  const n = (nif || '').toUpperCase().replace(/[\s.-]/g, '');
  if (!c && /^[A-Z]{2}[0-9A-Z]{5,}$/.test(n) && !n.startsWith('ES')) return 0;
  return 21;
};
